import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKomootComponent } from './simple-icons-komoot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKomootComponent ],
    exports:      [ SimpleIconsKomootComponent ],
    bootstrap:    []
})
export class SimpleIconsKomootModule {}
